/**
 * Handles clearing all files from the upload list.
 * Revokes all object URLs before clearing to prevent memory leaks.
 * Resets selectedIndex, uploadState and uploadProgress.
 */
export default class OnClearHandler {

    /**
     * @param {object} state - shared upload state from UploadAttachmentHandler
     */
    constructor(state) {
        this._state = state;
    }

    handle() {
        // Revoke all object URLs before wiping the list
        this._state.files.forEach((item) => {
            if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
        });

        this._state.files = [];
        this._state.selectedIndex = 0;
        this._state.uploadState = 'idle';
        this._state.uploadProgress = null;
    }
}
